import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

export const BROKER_REQUESTS_LIST = "BROKER_REQUESTS_LIST";
export const BROKER_REQUEST_DETAIL = "BROKER_REQUEST_DETAIL";
export const BROKER_REQUEST_REJECT = "BROKER_REQUEST_REJECT";
export const BROKER_REQUEST_APPROVE = "BROKER_REQUEST_APPROVE";
export const CLEAR_BROKER_REQUEST_ERRORS = "clearBrokerRequestErrors";

export const SET_BROKER_REQUEST_ERROR = "setBrokerRequestError";
export const REMOVE_BROKER_REQUEST_ERRORS = "removeBrokerRequestErrors";

const state = {
    errors: null,
};

const actions = {
    [BROKER_REQUESTS_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise((resolve) => {
            ApiService.simpledatatable("api/brokerrequests?" + payload.q)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: "error", msg: data._metadata.message});
                        context.commit(SET_BROKER_REQUEST_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_BROKER_REQUEST_ERROR, response && response.errors ? response.errors : null);
                });
        });
    },
    [BROKER_REQUEST_DETAIL](context, payload) {
        ApiService.setHeader();
        return new Promise((resolve, reject) => {
            ApiService.get("api/getbrokerrequestdetail/" + payload.source, payload.id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0 || data._metadata.outcomeCode === "0") {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: "error", msg: data._metadata.message});
                        reject(data);
                    }
                })
                .catch((err) => {
                    this.dispatch(SET_SNACK, {clr: "error", msg: "Failed to load broker request"});
                    reject(err);
                });
        });
    },
    [BROKER_REQUEST_REJECT](context, payload) {
        ApiService.setHeader();
        return new Promise((resolve, reject) => {
            ApiService.post(
                "api/rejectbrokerrequest/" + payload.source + "/" + payload.id,
                {reason: payload.reason}
            )
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0 || data._metadata.outcomeCode === "0") {
                        this.dispatch(SET_SNACK, {clr: "success", msg: data._metadata.message});
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: "error", msg: data._metadata.message});
                        reject(data);
                    }
                })
                .catch((err) => {
                    this.dispatch(SET_SNACK, {clr: "error", msg: "Failed to reject broker request"});
                    reject(err);
                });
        });
    },
    [BROKER_REQUEST_APPROVE](context, payload) {
        ApiService.setHeader();
        return new Promise((resolve, reject) => {
            ApiService.post(
                "api/approvebrokerrequest/" + payload.source + "/" + payload.id,
                {}
            )
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0 || data._metadata.outcomeCode === "0") {
                        this.dispatch(SET_SNACK, {clr: "success", msg: data._metadata.message});
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: "error", msg: data._metadata.message});
                        reject(data);
                    }
                })
                .catch((err) => {
                    this.dispatch(SET_SNACK, {clr: "error", msg: "Failed to approve broker request"});
                    reject(err);
                });
        });
    },
    [CLEAR_BROKER_REQUEST_ERRORS](context) {
        context.commit(REMOVE_BROKER_REQUEST_ERRORS);
    },
};

const mutations = {
    [SET_BROKER_REQUEST_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_BROKER_REQUEST_ERRORS](state) {
        state.errors = null;
    },
};

export default {
    state,
    actions,
    mutations,
};
